import { useEffect, useRef } from 'react';
import { useGetChildOffices } from '../../../domain/Users';
import { EmptyOffice } from './components/EmptyOffice';
import { OfficePreview } from './components/OfficePreview';

export const ChildOfficeSelect = ({
  parentOfficeId,
  defaultOfficeId,
  selectedOffice,
  onSelectOffice,
  onRemoveOffice,
}) => {
  const isInitialized = useRef(false);
  const { data } = useGetChildOffices(parentOfficeId);

  useEffect(() => {
    if (isInitialized.current) return;

    if (data?.length && defaultOfficeId) {
      isInitialized.current = true;
      onSelectOffice(data.find((office) => office.id === defaultOfficeId));
    }
  }, [data, defaultOfficeId, onSelectOffice]);

  return (
    <div
      className="card"
      style={{
        width: 200,
        height: 300,
        paddingTop: 16,
        paddingBottom: 24,
      }}
    >
      {selectedOffice ? (
        <OfficePreview office={selectedOffice} onRemove={onRemoveOffice} />
      ) : (
        <EmptyOffice officeList={data} onSelectOffice={onSelectOffice} />
      )}
    </div>
  );
};
